/**
 * TODO API接口对象
 * 发送http请求的接口集合
 */
// json类型的请求
import request from '@/api/request'
// form表单类型的请求
import requestForm from '@/api/requestForm'

const baseURL = 'https://dapp.crossfimain.com'

// 查询用户信息
export function getUser(address, eth) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getUser?address=' + address + '&eth=' + eth,
    method: 'get',
  })
}

// 获取邀请记录
export function getInvitateList(address, eth, page, size) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getInvitateList?address=' + address + '&eth=' + eth + '&page=' + page + '&size=' + size,
    method: 'get',
  })
}

// 获取奖励记录
export function getRewardList(address, eth, page, size) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getRewardList?address=' + address + '&eth=' + eth + '&page=' + page + '&size=' + size,
    method: 'get',
  })
}

// 查询公告列表
export function getGongList() {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/listNotice',
    method: 'get',
  })
}

// 查询公告列表
export function getBannerNoticeList() {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/listBannerNotice',
    method: 'get',
  })
}

// 查询公告信息
/*export function getGongMessage () {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getCurrent?address=' + (address ? address : '') + '&limit=' + limit + '&chainId=' + chainId,
    method: 'get',
  })
}*/

// 查询轮播列表
export function getSwiper() {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/listBanner',
    method: 'get',
  })
}

// 查询当前
export function getCurrent(address, limit, chainId) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getCurrent?address=' + (address ? address : '') + '&limit=' + limit + '&chainId=' + chainId,
    method: 'get',
  })
}

// 查询上一期
export function getPast(address, limit, current, chainId) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getPast?address=' + (address ? address : '') + '&limit=' + limit + '&current=' + current + '&chainId=' + chainId,
    method: 'get',
  })
}

// 查询上一期
export function getPastList(address, limit, chainId) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getPastList?address=' + (address ? address : '') + '&limit=' + limit + '&chainId=' + chainId,
    method: 'get',
  })
}

// 查询下一期
export function getNext(address, limit, current, chainId) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getNext?address=' + (address ? address : '') + '&limit=' + limit + '&current=' + current + '&chainId=' + chainId,
    method: 'get',
  })
}

// 查询预期
export function getFuture(address, limit, current, chainId) {
  return request({
    baseURL: baseURL,
    url: '/api/business/app/getFuture?address=' + (address ? address : '') + '&limit=' + limit + '&current=' + current + '&chainId=' + chainId,
    method: 'get',
  })
}

// 参与兑换
export function join(data) {
  return requestForm({
    baseURL: baseURL,
    url: '/api/business/app/参与兑换',
    method: 'post',
    data,
  })
}

// 提取
export function withdraw(data) {
  return requestForm({
    baseURL: baseURL,
    url: '/api/business/app/withdraw',
    method: 'post',
    data,
  })
}

// 日志
export function logSuccess(address, title, content) {
  let data = {}
  data.state = true
  data.address = address ? address : ''
  data.title = title
  data.cont = content
  return requestForm({
    baseURL: baseURL,
    url: '/api/business/app/log',
    method: 'post',
    data,
  })
}

export function logError(address, title, content, err) {
  let data = {}
  data.state = false
  data.address = address ? address : ''
  data.title = title
  if (Object.prototype.toString.call(err) === '[object Object]') {
    err = JSON.stringify(err)
  }
  data.cont = content + '----' + (err.length > 1900 ? err.substr(0, 1900) : err)
  return requestForm({
    baseURL: baseURL,
    url: '/api/business/app/log',
    method: 'post',
    data,
  })
}
